import { render, staticRenderFns } from "./OutClinicInvoices.vue?vue&type=template&id=76fd9bab"
import script from "./OutClinicInvoices.vue?vue&type=script&lang=js"
export * from "./OutClinicInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports